import { useRequest } from "~/api/Request"
import API from "~/api/api"
import { Activity } from "~/model/Activity"

export function useActivity() {
  const { Request } = useRequest()
  const getActivityData = async () => {
    const res = Request.get<Activity[]>(API.ACTIVITY)
    return res
  }

  return {
    getActivityData,
  }
}
